import React, { useEffect, useState } from "react";
import { Outlet, useNavigate, useLocation } from "react-router-dom";
import Header from "./Header";
import ParticleBackground from "./ParticleBackground";
import { useAuth } from "../context/AuthProvider";
import { jwtDecode } from "jwt-decode";
import { useMediaQuery } from "@mui/material";

export default function Layout() {
  const isMobile = useMediaQuery("(max-width:600px)");
  const [loading, setLoading] = useState(false);
  const [user, setUser] = useState("");
  const { token } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (!token) {
      navigate("/");
    } else {
      const decodedToken = jwtDecode(token);
      setUser(decodedToken);
    }
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    const checkTokenValidity = async () => {
      if (token) {
        try {
          const decodedToken = jwtDecode(token);
          if (decodedToken && decodedToken.exp * 1000 < Date.now()) {
            localStorage.removeItem("accessToken");
            navigate("/");
          }
        } catch (error) {
          localStorage.removeItem("accessToken");
          navigate("/");
        }
      } else {
        localStorage.removeItem("accessToken");
        navigate("/");
      }
    };

    const checkAdmin = async () => {
      const pathname = location.pathname.substring(1);
      const isAdmin = user.isAdmin === 1 ? true : false;
      const adminRoutes = [
        "dashboard",
        "doorprize",
        "package",
        "product",
        "sales",
        "user",
        "grandprize",
        "settingprize",
      ];
      if (!isAdmin && adminRoutes.some((route) => pathname.includes(route))) {
        navigate("/profile");
      }
    };

    if (user && typeof user.isAdmin !== "undefined") {
      checkAdmin();
    }

    checkTokenValidity();
  }, [token, navigate, location.pathname, user]);

  return (
    <div
      style={{
        position: "relative",
        width: "100%",
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
        backgroundImage: isMobile
          ? `linear-gradient(to bottom, transparent 70%, rgba(5,13,31,0.4) 100%), url("/Background Scenery Mobile.jpg")`
          : `linear-gradient(to bottom, transparent 45%, rgba(5,13,31,0.85) 75%, #050d1f 100%), url("/Background Scenery.jpg")`,
        backgroundSize: "cover",
        backgroundPosition: isMobile ? "center" : "top center",
        overflow: "hidden",
      }}
    >
      <ParticleBackground />
      {token && (
        <>
          <Header user={user} />
          <Outlet
            customer={user}
            context={{
              loading: [loading, setLoading],
              user: [user, setUser],
            }}
          />
        </>
      )}
    </div>
  );
}
